/*
  Project: Apka
  Author: Krzysztof
*/

var $ = require('jquery');
window.jQuery = window.$ = $; // You expose jQ as a global object

require('jquery-debouncedresize');

//var MenuSpy = require('menuspy');
//var vex = require('vex-js');
var scrollTo = require('jquery.scrollto');
var localScroll = require('jquery.localscroll');
var lightcase = require('lightcase');

 var breakpoint = {};

 breakpoint.refreshValue = function () {
   this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
 };

 function getMobileOperatingSystem() {
   var userAgent = navigator.userAgent || navigator.vendor || window.opera;

       // Windows Phone must come first because its UA also contains "Android"
     if (/windows phone/i.test(userAgent)) {
         return "windows-phone";
     }

     if (/android/i.test(userAgent)) {
         return "android";
     }

     // iOS detection from: http://stackoverflow.com/a/9039885/177710
     if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
         return "ios";
     }

     return "unknown";
 }

 var bodyClass = 'mobile-os-' + getMobileOperatingSystem();
 $('body').addClass(bodyClass);

 var menuButton = $('#menu-trigger');
 var menuWrapper = $('.c-header');

 menuButton.click(function() {
   $(this).toggleClass('is-active');
   menuWrapper.toggleClass('c-header--expanded');
   $('body').toggleClass('no-scroll');
 });

 // links handled by popup/ modal window
/*
 var images = $('.yt-popup').map(function(i,el) {
   $(this).on('click', function(){
     var url = this.href;
     var videoId = $(this).attr('data-vid');
     var moreLink = $(this).attr('data-more');
     var moreDesc = $(this).attr('data-moredesc');
     var title = this.title;
     var link = this.rel;

     vex.open({
       unsafeContent: '<h1 class="popup__title">'+title+'</h1><div class="popup__video"><iframe width="1280" height="720" src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe></div><div class="type--right"><a class="o-btn" href="'+moreLink+'">'+moreDesc+'</a></div>',
       className: 'popup',
       overlayClassName: 'popup__overlay',
       contentClassName: 'popup__content',
       closeClassName: 'popup__close',
       showCloseButton: true,
       escapeButtonCloses: true,
       appendLocation: 'body',
       afterClose: function(){
         $('body').toggleClass('no-scroll');
       }
     });
     $('body').toggleClass('no-scroll');
     return false;
   })
   return $(el).attr('href');
 });
*/
 // hash navigation with animation
 var nav = $('.c-main-nav');
 nav.localScroll({
     hash: true,
     reset: true,
     offset: -185
   });

  // menu spy
  var elm = document.querySelector('.c-main-nav');
  //var ms = new MenuSpy(elm);

  breakpoint.refreshValue();

  var h = document.querySelector('.c-header');
  var readout = document.getElementById("readout");
  var stuck = false;
  var stickPoint = getDistance();

  function getDistance() {
    var topDist = h.offsetTop;
    return 0;
  }

  window.onscroll = function(e) {
    var distance = getDistance() - window.pageYOffset;
    var offset = window.pageYOffset;
    if ( (distance <= 0) && !stuck) {
      //h.style.position = 'fixed';
      //h.style.top = '0px';
      if (!h.classList.contains('c-header--stuck')) {
         h.classList.add('c-header--stuck');
      }
      stuck = true;
    } else if (stuck && (offset <= stickPoint)){
      //h.style.position = 'static';
      if (h.classList.contains('c-header--stuck')) {
         h.classList.remove('c-header--stuck');
      }
      stuck = false;
    }
  }

	lightcase = $('a[data-rel^=lightcase]').lightcase({
		transition: 'scrollHorizontal',
		swipe: true,
    overlayOpacity: 1,
		labels: {
			'sequenceInfo.of': ' z ',
		},
		video: {
			width : "1920",
			height : "1080",
		}
	});


  $(window).on('debouncedresize', function(){
    breakpoint.refreshValue();
  });
